import { relatedComics, articleFAQs } from '@/mocks/article';
import { Link } from 'react-router-dom';

export default function RelatedAndFAQ() {
  return (
    <>
      <section className="w-full bg-background-100 py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8">
            相关推荐
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {relatedComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="group block cursor-pointer"
              >
                <div className="aspect-[3/4] rounded-lg overflow-hidden mb-2.5 bg-secondary-100">
                  <img
                    src={comic.image}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <h4 className="text-sm font-semibold text-foreground-950 truncate">{comic.title}</h4>
                <p className="text-xs text-foreground-500">{comic.author} &middot; {comic.rating}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
            常见问题
          </h2>
          <div className="max-w-3xl mx-auto space-y-3">
            {articleFAQs.map((faq, idx) => (
              <details key={idx} className="group bg-white rounded-lg p-5 cursor-pointer">
                <summary className="flex items-center justify-between text-sm font-semibold text-foreground-950 list-none">
                  {faq.question}
                  <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                </summary>
                <p className="mt-3 text-xs text-foreground-600 leading-relaxed">{faq.answer}</p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}